module.exports = __webpack_public_path__ + "img/labmem_text_title_tc.9d480f07.png";